import RouteGuard from './RouteGuard'

export default RouteGuard